"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcInputBehavior = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
var default_behavior_1 = require("../../../common/models/default-behavior");
var bc_input_constants_1 = require("./bc-input-constants");
var bc_input_constants_2 = require("./bc-input-constants");
var helpers_1 = require("../../../common/helpers");
var BcInputBehavior = (function (_super) {
    __extends(BcInputBehavior, _super);
    function BcInputBehavior() {
        var _this = _super.call(this) || this;
        _this.checkInput = function (value) { return value !== null && value !== undefined && value !== ''; };
        _this.addRemoveClass = function (bool, myself) {
            bool ? myself.classList.add(bc_input_constants_1.INPUT_ACTIVE_CLASS) : myself.classList.remove(bc_input_constants_1.INPUT_ACTIVE_CLASS);
        };
        _this.updateState = function (event) {
            if (_this.mySelf) {
                _this.addRemoveClass(_this.checkInput(_this.mySelf.value), _this.mySelf);
            }
        };
        return _this;
    }
    BcInputBehavior.prototype.setMyLastClass = function (myLastClass) {
        this.myLastClass = myLastClass;
    };
    BcInputBehavior.prototype.getMyLastClass = function () {
        return this.myLastClass;
    };
    BcInputBehavior.setUpAll = function () {
        var imgElements = Array.from(document.querySelectorAll("[class^='".concat(bc_input_constants_1.INPUT_CLASS, "']")));
        var elements = [];
        for (var _i = 0, imgElements_1 = imgElements; _i < imgElements_1.length; _i++) {
            var element = imgElements_1[_i];
            var bc = new BcInputBehavior();
            bc.setElement(element);
            bc.setUp();
            elements.push(bc);
        }
        return elements;
    };
    BcInputBehavior.prototype._setUp = function () {
        this.addPaddingRightWhenIcon(this.mySelf);
        this.addRemoveClass(this.checkInput(this.mySelf.value), this.mySelf);
        this.mySelf.addEventListener(common_constants_1.BcCommonConstants.EVENT_INPUT, this.updateState);
        this.getInputs();
        this.setMyLastClass(this.mySelf.className);
        this.getMyLastClass();
        this.watchClassChanges(this.mySelf);
        this.inputValueListener(this.mySelf);
    };
    BcInputBehavior.prototype.getInputs = function () {
        var inputs = Array.from(document.querySelectorAll("[class~='".concat(bc_input_constants_1.INPUT_CLASS, "']")));
        for (var _i = 0, inputs_1 = inputs; _i < inputs_1.length; _i++) {
            var input = inputs_1[_i];
            (0, helpers_1.addFocusable)(input, { tabindex: '0' });
        }
    };
    BcInputBehavior.prototype.inputValueListener = function (input) {
        var _this = this;
        if (input.classList.value.includes(bc_input_constants_1.BC_INPUT_VALUE_CLASS)) {
            input.addEventListener(common_constants_1.BcCommonConstants.EVENT_INPUT, function (e) {
                _this.formatInputValue(e, input);
                _this.updateState(e);
            });
        }
    };
    BcInputBehavior.prototype.formatInputValue = function (e, input) {
        if (e['data'] === ' ') {
            input.value = input.value.split(' ').join('');
        }
        var num = (input.value).replace(/\./g, '');
        if (!isNaN(num)) {
            num = num.toString().split('').reverse().join('').replace(/(?=\d*\.?)(\d{3})/g, '$1.');
            num = num.split('').reverse().join('').replace(/^[\.]/, '');
            input.value = num;
        }
        else {
            input.value = input.value.replace(/[^\d\.]*/g, '');
        }
    };
    BcInputBehavior.prototype.addPaddingRightWhenIcon = function (input) {
        if (this.checkSiblingElementEM(input)) {
            input.classList.add(bc_input_constants_2.INPUT_PADDING_RIGHT_WHEN_ICON);
        }
    };
    BcInputBehavior.prototype.checkSiblingElementEM = function (input) {
        if (input.nextElementSibling !== null) {
            return input.nextElementSibling.nodeName.toLowerCase() === bc_input_constants_1.EM_TAG;
        }
        else {
            return false;
        }
    };
    BcInputBehavior.prototype.validateFlow = function (myLastClass, currentClass) {
        this.lastClassDontHaveClassess = (!(myLastClass.includes(bc_input_constants_2.INPUT_ERROR_CLASS) || myLastClass.includes(bc_input_constants_1.INPUT_SUCCESS_CLASS))
            && (currentClass.includes(bc_input_constants_2.INPUT_ERROR_CLASS) || currentClass.includes(bc_input_constants_1.INPUT_SUCCESS_CLASS)));
        this.removeTheIcon = ((myLastClass.includes(bc_input_constants_2.INPUT_ERROR_CLASS) || myLastClass.includes(bc_input_constants_1.INPUT_SUCCESS_CLASS))
            && !(currentClass.includes(bc_input_constants_2.INPUT_ERROR_CLASS) || currentClass.includes(bc_input_constants_1.INPUT_SUCCESS_CLASS)));
        this.changeToTheOtherClass = ((myLastClass.includes(bc_input_constants_2.INPUT_ERROR_CLASS) || myLastClass.includes(bc_input_constants_1.INPUT_SUCCESS_CLASS)) && myLastClass !== currentClass);
    };
    BcInputBehavior.prototype.watchClassChanges = function (mySelf) {
        var _this = this;
        this.setMyLastClass(mySelf.className);
        var observer = new MutationObserver(function (event) {
            var _a;
            var currentClass = event[0].target.className;
            var myLastClass = _this.getMyLastClass();
            if (currentClass.includes(bc_input_constants_1.BC_INPUT_VALIDATION_CLASS)) {
                _this.validateFlow(myLastClass, currentClass);
                if (_this.lastClassDontHaveClassess) {
                    _this.bcInputValidation(mySelf);
                }
                else if (_this.removeTheIcon) {
                    _this.removeIconAndPadding(mySelf);
                    (_a = mySelf.nextElementSibling) === null || _a === void 0 ? void 0 : _a.classList.remove(bc_input_constants_1.INVISIBLE_CLASS);
                    _this.setMyLastClass(mySelf.className);
                    _this.addRemoveClass(_this.checkInput(_this.mySelf.value), _this.mySelf);
                    _this.addPaddingRightWhenIcon(mySelf);
                }
                else if (_this.changeToTheOtherClass) {
                    _this.bcInputValidation(mySelf);
                }
            }
        });
        observer.observe(this.mySelf, {
            attributes: true,
            attributeFilter: ['class'],
            childList: false,
            characterData: false
        });
    };
    BcInputBehavior.prototype.removeIconAndPadding = function (input) {
        if (this.checkSiblingElementEM(input)) {
            input.nextElementSibling.remove();
            input.style.paddingRight = '';
        }
    };
    BcInputBehavior.prototype.bcInputValidation = function (input) {
        var _a;
        var nextElementToInput = input.nextElementSibling;
        var emElement;
        if (this.checkNextElmentToInput(nextElementToInput)) {
            if (this.checkIfButtonIsErrorOSuccess(nextElementToInput.innerHTML)) {
                if (this.checkIfBottonAlreadyExist(nextElementToInput.innerHTML, input.className)) {
                    return;
                }
                else {
                    (_a = nextElementToInput.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(nextElementToInput);
                }
            }
            else {
                nextElementToInput.classList.add(bc_input_constants_1.INVISIBLE_CLASS);
            }
        }
        if (input.className.includes(bc_input_constants_1.INPUT_SUCCESS_CLASS)) {
            emElement = this.createElementEM();
            this.setSuccesIconography(emElement);
            input.insertAdjacentElement(common_constants_1.BcCommonConstants.AFTER_END, emElement);
        }
        else if (input.className.includes(bc_input_constants_2.INPUT_ERROR_CLASS)) {
            emElement = this.createElementEM();
            this.setErrorIconography(emElement, input);
            input.insertAdjacentElement(common_constants_1.BcCommonConstants.AFTER_END, emElement);
        }
        input.style.paddingRight = '24px';
        this.setMyLastClass(input.className);
        this.addRemoveClass(this.checkInput(this.mySelf.value), this.mySelf);
    };
    BcInputBehavior.prototype.setSuccesIconography = function (emElement) {
        emElement.innerHTML = bc_input_constants_2.BC_INPUT_SUCCESSFUL_ICON;
    };
    BcInputBehavior.prototype.checkIfBottonAlreadyExist = function (nameButton, classess) {
        var tempClass;
        if (nameButton === bc_input_constants_2.BC_INPUT_SUCCESSFUL_ICON) {
            tempClass = bc_input_constants_1.INPUT_SUCCESS_CLASS;
        }
        else {
            tempClass = bc_input_constants_2.INPUT_ERROR_CLASS;
        }
        if (classess.includes(tempClass)) {
            return true;
        }
        else {
            return false;
        }
    };
    BcInputBehavior.prototype.checkIfButtonIsErrorOSuccess = function (nameButton) {
        if (nameButton === bc_input_constants_2.BC_INPUT_SUCCESSFUL_ICON || nameButton === bc_input_constants_2.BC_INPUT_REMOVE_ICON) {
            return true;
        }
        else {
            return false;
        }
    };
    BcInputBehavior.prototype.setErrorIconography = function (emElement, input) {
        emElement.innerHTML = bc_input_constants_2.BC_INPUT_REMOVE_ICON;
        (0, helpers_1.addFocusable)(emElement, { tabindex: '0' });
        emElement.classList.add(bc_input_constants_2.INPUT_BUTTON_ICON_CLASS);
        emElement.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
            input.className = input.className.replace(bc_input_constants_2.INPUT_ERROR_CLASS, '');
            input.className = input.className.replace(bc_input_constants_1.INPUT_ACTIVE_CLASS, '');
            input.value = '';
            input.focus();
        });
        this.addScreenReader(emElement);
    };
    BcInputBehavior.prototype.checkNextElmentToInput = function (nextElementToInput) {
        if (nextElementToInput.nodeName.toLowerCase() == common_constants_1.BcCommonConstants.EM_TAG) {
            return true;
        }
        else {
            return false;
        }
    };
    BcInputBehavior.prototype.createElementEM = function () {
        return document.createElement(bc_input_constants_1.EM_TAG);
    };
    BcInputBehavior.prototype.addScreenReader = function (element) {
        var _this = this;
        element.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_UP, function (event) {
            if (event.key === ' ') {
                _this.focusNext(element);
            }
        });
    };
    BcInputBehavior.prototype.focusNext = function (element) {
        element.click();
    };
    return BcInputBehavior;
}(default_behavior_1.BcDefaultBehavior));
exports.BcInputBehavior = BcInputBehavior;
